module.exports = __webpack_public_path__ + "media/images/iconTrend--same-8a25cc67766ab3df53609c10cd4cacf7.png";